import { WorkspacePanel } from '../../panels/workspace-panel';
import {
    BoloQueueRowData,
    EventQueueRowData,
    ScheduledEventQueueRowData,
    UnitQueueRowData,
} from '../../socket/stream-types';

export const isUnitQueue = (panel: WorkspacePanel, data: unknown): data is UnitQueueRowData => {
    return panel.queue?.dataEntityType === 'UNIT';
};

export const isScheduledEventQueue = (
    panel: WorkspacePanel,
    data: unknown
): data is ScheduledEventQueueRowData => {
    return panel.queue?.dataEntityType === 'SCHEDULED_AGENCY_EVENT';
};

export const isEventQueue = (panel: WorkspacePanel, data: unknown): data is EventQueueRowData => {
    return panel.queue?.dataEntityType === 'CAD_AGENCY_EVENT';
};

export const isBoloQueue = (panel: WorkspacePanel, data: unknown): data is BoloQueueRowData => {
    return panel.queue?.dataEntityType === 'BOLO';
};
